module.exports = __webpack_public_path__ + "static/logo-641129ed6af1df1c26845404c2b8c896.png";